import {
    AI_ASSISTANT_USER,
    DECISION_USER,
    EXPLORE_USER,
    SUPPORT,
} from 'business/constants';
import type { ModuleT } from 'business/types';
import { AI_ASSISTANT, ESSENTIAL } from 'shared/constants';
import type { ExtraFeatureT } from 'shared/types';
import { useSelector } from 'store/hooks';

import type { UserRole } from '../business/definitions';

export const useClientHasModule = (module: ModuleT) =>
    useSelector((state) => state.vision.client.modules?.includes(module));

const useClientHasExtraFeature = (extraFeature: ExtraFeatureT) =>
    useSelector((state) =>
        state.vision.client.extraFeatures?.includes(extraFeature),
    );

export const useClientExtraFeatures = (): ExtraFeatureT[] =>
    useSelector((state) => state.vision.client.extraFeatures ?? []);

export const useUserHasRole = (role: UserRole) =>
    useSelector((state) => state.vision.user.roles.includes(role));

export const useIsExploreUser = () => {
    const roles: UserRole[] = [DECISION_USER, EXPLORE_USER];
    const isSupport = useUserHasRole(SUPPORT);
    return (
        useSelector((state) =>
            roles.every((r) => state.vision.user.roles.includes(r)),
        ) || isSupport
    );
};

export const useIsEssential = () => useClientHasExtraFeature(ESSENTIAL);

export const useCanUseAiAssistant = () => {
    const hasRole = useUserHasRole(AI_ASSISTANT_USER);
    const hasExtraFeature = useClientHasExtraFeature(AI_ASSISTANT);
    return hasRole && hasExtraFeature;
};
